import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EnergyLineChartType } from '../../EnergyLineChart';
import RadioButton from '../../RadioButton';
import RadioGroup from '../RadioGroup';
const EnergyChartTypeToggle = ({ chartType, setChartType, }) => {
    return (_jsxs(RadioGroup, { children: [_jsx(RadioButton, { label: EnergyLineChartType.POWER, value: EnergyLineChartType.POWER, checked: chartType === EnergyLineChartType.POWER, onChange: () => setChartType(EnergyLineChartType.POWER) }, void 0), _jsx(RadioButton, { label: EnergyLineChartType.CURRENT, value: EnergyLineChartType.CURRENT, checked: chartType === EnergyLineChartType.CURRENT, onChange: () => setChartType(EnergyLineChartType.CURRENT) }, void 0)] }, void 0));
};
export default EnergyChartTypeToggle;
